export default "__VITE_ASSET__789a977e__"